import { render, staticRenderFns } from "./DocumentTools.vue?vue&type=template&id=b76f1374&"
import script from "./DocumentTools.vue?vue&type=script&lang=js&"
export * from "./DocumentTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports